function formatNumberRibuan(value) {
  return new Intl.NumberFormat("id-ID").format(value);
}

function formatRupiahUtil(value) {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0, // Tidak ada angka desimal
  }).format(value);
}

export { formatNumberRibuan, formatRupiahUtil };
